import React from "react";
import Picker from "emoji-picker-react";
import { Trash, X, Smile, Send, ArrowDown, Mail, MoreHorizontal, PlusSquare } from "react-feather";
import PresetsList from "./PresetsList";
import SliderPaste from "./SliderPaste";
import SliderFiles from "./SliderFiles";
import RecordView from "./RecordView";

function BulkComposer({
  isEmojiModalOpen,
  setIsEmojiModalOpen,
  isModalpasteImages,
  pasteImagesSlider,
  deletePasteImages,
  isModalSelectedFiles,
  selectedFilesSlider,
  deleteSelectedImages,
  isModalPresets,
  presets,
  onEmojiClick,
  getRootProps,
  getInputProps,
  recordTrigger,
  setRecordTrigger,
  currentChatId,
  updateAllChats,
  updateMessagesById,
  textAreaRef,
  message,
  handleTyping,
  setMessage,
  handlePasteArchives,
  handlePasteText,
  handleSendEmail,
  openTemplateContract,
  openTemplate,
  inputFileRef,
  handleFiles,
  sendMessageToMultiple,
}) {
  return (
    <>
      <div className={`media-options ${!isEmojiModalOpen && "display-none"}`}>
        {!isModalpasteImages && !isModalSelectedFiles && !isModalPresets ? (
          <Picker onEmojiClick={onEmojiClick} pickerStyle={{ width: "100%", height: "300px" }} />
        ) : ""}

        {isModalPresets && (
          <PresetsList presets={presets} usePreset={() => {}} />
        )}

        <button style={{ position: "absolute", margin: "95px 0 0 95px" }} className={`action-btn ${!isModalpasteImages && "display-none"}`} onClick={e => { e.preventDefault(); deletePasteImages() }}>
          <Trash size={80} />
        </button>
        {isModalpasteImages && (
          <SliderPaste images={pasteImagesSlider} />
        )}

        <button style={{ position: "absolute", margin: "70px 0 0 70px" }} className={`action-btn  ${!isModalSelectedFiles && "display-none"}`} onClick={e => { e.preventDefault(); deleteSelectedImages() }}>
          <Trash size={80} />
        </button>
        {isModalSelectedFiles && (
          <SliderFiles files={selectedFilesSlider} />
        )}
      </div>

      <form className="actions" {...getRootProps({ className: "dropzone" })}>
        <input {...getInputProps()} />

        <RecordView trigger={recordTrigger} setTrigger={setRecordTrigger} chat_id={currentChatId} updateAllChats={updateAllChats} updateMessagesById={updateMessagesById} />

        {!recordTrigger && (
          <div className="inner-actions">
            <div className="actions-above">
              <textarea
                ref={textAreaRef}
                className="message-input-sender"
                rows="3"
                placeholder="Escreva a mensagem..."
                value={message}
                onKeyDown={e => handleTyping(e)}
                onChange={e => setMessage(e.target.value)}
                onPaste={e => { handlePasteArchives(e); handlePasteText(e) }}
              />
            </div>
            <div className="actions-below mt-10">
              <div />
              <div>
                <button className="action-btn mr-20" onClick={handleSendEmail}>
                  <Mail />
                </button>

                <a href="#bottom" className="action-btn mr-20">
                  <ArrowDown />
                </a>

                <button className="action-btn mr-20" onClick={openTemplateContract}>
                  <PlusSquare />
                </button>

                <button className="action-btn mr-20" onClick={openTemplate}>
                  <MoreHorizontal />
                </button>

                <button className="action-btn mr-20" onClick={e => { e.preventDefault(); setIsEmojiModalOpen(!isEmojiModalOpen) }}>
                  {isEmojiModalOpen ? <X /> : <Smile />}
                </button>

                <label className="action-btn mr-20">
                  <input
                    hidden
                    ref={inputFileRef}
                    type="file"
                    draggable
                    multiple
                    accept="video/*, image/*, .pdf, audio/*, .ogg, .oga"
                    onChange={e => handleFiles(e)}
                    onDrag={e => handlePasteArchives(e)}
                  />
                  Anexar
                </label>

                <button className="action-btn" type="button" onClick={sendMessageToMultiple}>
                  <Send />
                </button>
              </div>
            </div>
          </div>
        )}
      </form>
    </>
  );
}

export default BulkComposer;

